import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { pluck, map } from 'rxjs/operators';
import { ImagilityBaseResponse } from 'src/app/data/models/response.model';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {

private state: { searchText: string; pageSize: number; pageIndex: number, includeAssociate: boolean } = {
  searchText: '',
  pageSize: 25,
  pageIndex: 0,
  includeAssociate: false
};

constructor(private httpClient: HttpClient) { }

setState(state: Partial<{ searchText: string; pageSize: number; pageIndex: number; includeAssociate: boolean }>) {
  this.state = { ...this.state, ...state };
}

getState() {
  return this.state;
}

getReviewSummary(companyId){
  return this.httpClient.get(`/attorney/company/${companyId}/reviewSummary`).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

postReviewSummary(companyId,payload){
  return this.httpClient.post(`/attorney/company/${companyId}/reviewSummary`,payload).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
}

getUserRoles(){
  return this.httpClient.get(`/default/user/roles`).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

getUserRolesByCompany(companyId){
  return this.httpClient.get(`/company/${companyId}/role`).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

getUserDetails(companyId, payload){
  return this.httpClient.post(`/company/${companyId}/user/roles/list`, payload).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

getBeneficiaryDetails(companyId){
  return this.httpClient.get(`/beneficiaries/company/${companyId}`).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

getSendInviteList(companyId){
  return this.httpClient.get(`/getSendInviteListFromLinkRequestByCompany/${companyId}`).pipe(
    map((response: ImagilityBaseResponse) => response.data)
  );
}

createUser(companyId,payload){
  return this.httpClient.post(`/company/${companyId}/createUser`, payload).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
}

createBeneficiary(payload){
  return this.httpClient.post(`/attorney/beneficiary/create`, payload).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
}

createSendInviteBeneficiary(payload){
  return this.httpClient.post(`/petitioner/dashboard/beneficiaries/create`, payload).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
}

assignRoles(companyId,payload){
  return this.httpClient.post(`/company/${companyId}/assignRoles`, payload).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
}

deleteUser(companyId,employeeId){
  return this.httpClient.delete(`/company/${companyId}/createUser/${employeeId}`).pipe(
    map((response: ImagilityBaseResponse) => {
        return response; // send  full data
    })
  );
 }

 deleteBeneficiary(companyId,beneficiary_id){
  return this.httpClient.delete(`/beneficiary/${beneficiary_id}/profile/deleteByAttorney/${companyId}`).pipe(
    map((response: ImagilityBaseResponse) => {
        return response; // send  full data
    })
  );
 }

 deleteSendInviteBeneficiary(linkRequestId){
  return this.httpClient.delete(`/attorney/deleteLinkRequest/${linkRequestId}`).pipe(
    map((response: ImagilityBaseResponse) => {
        return response; // send  full data
    })
  );
 }

 deleteDraftClient(companyId,employeeId){
  return this.httpClient.delete(`/company/${companyId}/createUser/${employeeId}`).pipe(
    map((response: ImagilityBaseResponse) => {
        return response; // send  full data
    })
);
 } 

 delinkConnection(petitionerId,attorneyCompanyId){
  return this.httpClient.post(`/petitioner/${petitionerId}/deLinkWithAttorney/${attorneyCompanyId}`, []).pipe(
    map((response: ImagilityBaseResponse) => response)
  );
 }



}
